import { NgIf } from '@angular/common';
import { Component, inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormsModule, NgModel, ValidationErrors } from '@angular/forms';
import { MatIconButton, MatMiniFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource } from '@angular/material/table';
import { GeschaedigtesGeraet } from '@gsm/entities';
import { WINDOW } from 'ngx-window-token';
import { filterEmptyProps } from '../../helpers/filter-props.helper';
import { AlphanumValidator } from '../../validators/alphanum.validator';
import { CustomDynamicFormControlComponent } from '../custom-dynamic-form-control.component';
import { GeschaedigteGeraeteEinfachModel } from './geschaedigte-geraete-einfach.model';

// NOTE:
// The base class CustomDynamicFormControlComponent already includes all inputs and outputs needed, as well
// as additional convenience methods onDisabledChange() and onValueChange, for when model.disabled and model.value change,
// respectively.

@Component({
  selector:    'gsm-geschaedigte-geraete-einfach',
  templateUrl: 'geschaedigte-geraete-einfach.component.html',
  styleUrls:   ['geschaedigte-geraete-einfach.component.scss'],
  standalone:  true,
  imports:     [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatInput,
    FormsModule,
    AlphanumValidator,
    NgIf,
    MatIconButton,
    MatIcon,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatMiniFabButton
  ]
})
export class GeschaedigteGeraeteEinfachComponent extends CustomDynamicFormControlComponent<GeschaedigteGeraeteEinfachModel>
  implements OnInit {

  private window = inject<Window>(WINDOW);

  itemList = new MatTableDataSource<GeschaedigtesGeraet>();
  displayedColumns: string[] = [
    'art',
    'marke',
    'typenbezeichnung',
    'notiz',
    'delete'
  ];

  @ViewChildren('art') artModels: QueryList<NgModel>;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected onModelChange() {
    if (!this.model.value || !this.model.value.length) {
      this.itemList.data = [];
      this.addItem();
    } else {
      this.itemList.data = this.model.value;
    }
    this.window.setTimeout(() => {
      this._emitChange();
    }, 0);
  }

  onInputBlur() {
    this.onFormValueChange();
  }

  onFormValueChange() {
    this.model.value = this.itemList.data.map(item => filterEmptyProps(item))
      .filter(item => Object.keys(item).length);
    this._markRequiredFieldsTouched();
    this._emitChange();
  }

  private _markRequiredFieldsTouched() {
    if (this.artModels) {
      this.artModels.forEach(mod => mod.control.markAsTouched());
    }
  }

  private _emitChange() {
    this.group.get(this.model.id)
      .setErrors(this._getErrors());
    this.change.emit(this.model.value);
  }

  private _getErrors(): ValidationErrors {
    let invalid = true;
    const artInvalid = !!this.itemList.data.find(item => item && !item.art);
    if (!artInvalid) {
      invalid = false;
    }
    return invalid ? {geschaedigteGeraeteAufstellung: true} : null;
  }

  addItem() {
    const newGgItem: GeschaedigtesGeraet = {
      art:              null,
      marke:            null,
      typenbezeichnung: null,
      notiz:            null
    };
    const data = this.itemList.data;
    data.push(newGgItem);
    this.itemList.data = data;
    this.onFormValueChange();
  }

  deleteItem(index: number) {
    if (this.itemList.data.length > 1) {
      const data = this.itemList.data;
      data.splice(index, 1);
      this.itemList.data = data;
      this.onFormValueChange();
    } else if (index === 0) {
      this.resetItem(this.itemList.data[0]);
    }
  }

  resetItem(item: GeschaedigtesGeraet) {
    item.art = null;
    item.marke = null;
    item.typenbezeichnung = null;
    item.notiz = null;
    this.onFormValueChange();
  }
}
